import { getPrimaryColorGradient } from './utils/colors';

export const NEW_SESSION_PATH = '/sessions/new';
export const COGNITO_REFRESH_TOKEN_INTERVAL = 240000; // 4 minutes
export const REFRESH_TOKEN_INTERVAL = 180000; // every 3 minutes
export const HELPDESK_ISSUE_MAX_RETRIES = 3;
export const DEFAULT_DATA_PLACEHOLDER = '---';
export const HHMMSS_PLACEHOLDER = 'hh:mm:ss';
export const TIME_FORMAT = 'HH:mm:ss';
export const DATE_FORMAT = 'yyyy-MM-dd';
export const COLUMN_LABEL_MULTIPLIER = 16;
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const SNACKBAR_TIMEOUT = 3000;
export const SNACKBAR_TIMEOUT_LONGER = 5000;
export const RELOAD_DELAY = 10000;
export const TEAM_GROUPING_ID = '-1';
export enum TEAM_PLAN {
  lt = 'LIGHT',
  smart = 'SMART',
  top = 'TOP',
}
export const DEFAULT_COLORS = [
  'rgb(255, 55, 0)',
  'rgb(153, 0, 204)',
  'rgb(102, 0, 204)',
  'rgb(51, 102, 153)',
  'rgb(51, 204, 255)',
  'rgb(51, 204, 204)',
  'rgb(51, 153, 153)',
  'rgb(51, 153, 102)',
  'rgb(153, 204, 102)',
  'rgb(204, 204, 0)',
  'rgb(255, 51, 255)',
  'rgb(255, 204, 0)',
  'rgb(255, 153, 51)',
  'rgb(255, 102, 0)',
  'rgb(102, 51, 255)',
  'rgb(102, 102, 153)',
];

export const WEB_SAFE_COLORS = {
  'rgb(255, 51, 102)': '#FF3366',
  'rgb(153, 0, 204)': '#9900CC',
  'rgb(102, 0, 204)': '#6600CC',
  'rgb(51, 102, 153)': '#336699',
  'rgb(51, 204, 255)': '#33CCFF',
  'rgb(51, 204, 204)': '#33CCCC',
  'rgb(51, 153, 153)': '#339999',
  'rgb(51, 153, 102)': '#339966',
  'rgb(153, 204, 102)': '#99CC66',
  'rgb(204, 204, 0)': '#CCCC00',
  'rgb(255, 51, 255)': '#FF33FF',
  'rgb(255, 204, 0)': '#FFCC00',
  'rgb(255, 153, 51)': '#FF9933',
  'rgb(255, 102, 0)': '#FF6600',
  'rgb(102, 51, 255)': '#6633FF',
  'rgb(102, 102, 153)': '#666699',
  'rgb(255, 55, 0)': '#ff3700',
};

export const greenColors = getPrimaryColorGradient(6).reverse();

export const blueColors = ['#002960', '#0050bd', '#0063e9', '#4488e3', '#76b9df', '#ace2f3'];

export const redColors = ['#640017', '#9d0025', '#ba002c', '#d50032', '#ed8ba2', '#ffe5eb'];

export const HIGHCHART_OPTIONS = {
  MaxColumnWidth: 100,
};

export const HIGHCHART_COLORS = ['#2caffe', '#544fc5', '#00e272', '#fe6a35', '#6b8abc', '#d568fb', '#2ee0ca', '#fa4b42', '#feb56a', '#91e8e1'];

export const RPEType1 = 'A_1';
export const RPEType2 = 'A_2';
export const RPEExtremes = {
  RPEType1: {
    max: 11,
    min: 0,
  },
  RPEType2: {
    max: 20,
    min: 6,
  },
};

export const TIME_COURSE_KPI = 6;

export const PROFILE_DELTA_DAYS = 30;

export const DEFAULT_DECIMALS_NUM = 1;

export const MY_STATS_LIMIT = 25;

// webPlayer
export const loadingTimeFrame = 300; // 5 minuti
export const FPS = 15;
export const maxSamplesPerFrame = 10;

export const isKpiForLive = (input: string) => {
  const kpiStrings = [
    'speed',
    'power',
    'power_aer',
    'cardio',
    'cardio_percentual',
    'equivalent_distance',
    'power_events',
    'acceleration_events',
    'deceleration_events',
    'speed_events',
    'relative_speed_events',
    'event_jumps_count',
    'event_impacts_count',
    'max_values_speed',
    'max_speed_percentual',
    'max_values_power',
    'total_distance',
    'equivalent_distance_index',
    'total_energy',
    'average_v',
    'average_hr',
    'average_hr_percentual',
    'high_metabolic_load_distance',
    'max_values_cardio_percentual',
    'max_values_cardio',
    'average_p',
    'power_aer_perc',
    // Mechanical events (chiavi report series gpexe)
    'tot_burst_events',
    'tot_brake_events',
    // External work
    'external_work',
    // Speed zones
    'athletesessionspeedzone_distance_1',
    'athletesessionspeedzone_distance_2',
    'athletesessionspeedzone_distance_3',
    'athletesessionspeedzone_distance_4',
    'athletesessionspeedzone_distance_5',
    'athletesessionspeedzone_distance_6',
    'athletesessionspeedzone_distance_2_plus',
    'athletesessionspeedzone_distance_3_plus',
    'athletesessionspeedzone_distance_4_plus',
    'athletesessionspeedzone_distance_5_plus',
    'athletesessionspeedzone_distance_6_plus',
    // Relative speed zones
    'athletesessionrelativespeedzone_distance_1',
    'athletesessionrelativespeedzone_distance_2',
    'athletesessionrelativespeedzone_distance_3',
    'athletesessionrelativespeedzone_distance_4',
    'athletesessionrelativespeedzone_distance_5',
    'athletesessionrelativespeedzone_distance_6',
    'athletesessionrelativespeedzone_distance_2_plus',
    'athletesessionrelativespeedzone_distance_3_plus',
    'athletesessionrelativespeedzone_distance_4_plus',
    'athletesessionrelativespeedzone_distance_5_plus',
    'athletesessionrelativespeedzone_distance_6_plus',
    // Acceleration zones
    'athletesessionaccelerationzone_distance_1',
    'athletesessionaccelerationzone_distance_2',
    'athletesessionaccelerationzone_distance_3',
    'athletesessionaccelerationzone_distance_4',
    'athletesessionaccelerationzone_distance_5',
    'athletesessionaccelerationzone_distance_6',
    'athletesessionaccelerationzone_distance_2_plus',
    'athletesessionaccelerationzone_distance_3_plus',
    'athletesessionaccelerationzone_distance_4_plus',
    'athletesessionaccelerationzone_distance_5_plus',
    'athletesessionaccelerationzone_distance_6_plus',
    // Deceleration zones
    'athletesessiondecelerationzone_distance_1',
    'athletesessiondecelerationzone_distance_2',
    'athletesessiondecelerationzone_distance_3',
    'athletesessiondecelerationzone_distance_4',
    'athletesessiondecelerationzone_distance_5',
    'athletesessiondecelerationzone_distance_6',
    'athletesessiondecelerationzone_distance_2_plus',
    'athletesessiondecelerationzone_distance_3_plus',
    'athletesessiondecelerationzone_distance_4_plus',
    'athletesessiondecelerationzone_distance_5_plus',
    'athletesessiondecelerationzone_distance_6_plus',
    // Heart rate (cardio) zones
    'athletesessionheartratezone_time_1',
    'athletesessionheartratezone_time_2',
    'athletesessionheartratezone_time_3',
    'athletesessionheartratezone_time_4',
    'athletesessionheartratezone_time_5',
    'athletesessionheartratezone_time_6',
    'athletesessionheartratezone_time_2_plus',
    'athletesessionheartratezone_time_3_plus',
    'athletesessionheartratezone_time_4_plus',
    'athletesessionheartratezone_time_5_plus',
    'athletesessionheartratezone_time_6_plus',
  ];

  return kpiStrings.includes(input);
};

export const FONT_FAMILY = 'Roboto';
export const DEFAULT_TEXT_COLOR = '#828282';

export const GROUND_MAX_ANGLE_TOLERANCE = 3;
export const GROUND_MIN_RATIO = 1 / 3;
export const GROUND_MAX_RATIO = 10;
